'use client';
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
var TABBABLE_NODES = /input|select|textarea|button|object/;
var FOCUS_SELECTOR = "a, input, select, textarea, button, object, [tabindex]";
function hidden(element) {
    if (process.env.NODE_ENV === "test") {
        return false;
    }
    return element.style.display === "none";
}
function visible(element) {
    var isHidden = element.getAttribute("aria-hidden") || element.getAttribute("hidden") || element.getAttribute("type") === "hidden";
    if (isHidden) {
        return false;
    }
    var parentElement = element;
    while(parentElement){
        if (parentElement === document.body || parentElement.nodeType === 11) {
            break;
        }
        if (hidden(parentElement)) {
            return false;
        }
        parentElement = parentElement.parentNode;
    }
    return true;
}
function getElementTabIndex(element) {
    var tabIndex = element.getAttribute("tabindex");
    if (tabIndex === null) {
        tabIndex = undefined;
    }
    return parseInt(tabIndex, 10);
}
function focusable(element) {
    var nodeName = element.nodeName.toLowerCase();
    var isTabIndexNotNaN = !Number.isNaN(getElementTabIndex(element));
    var res = TABBABLE_NODES.test(nodeName) && !element.disabled || (_instanceof(element, HTMLAnchorElement) ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
    return res && visible(element);
}
function tabbable(element) {
    var tabIndex = getElementTabIndex(element);
    var isTabIndexNaN = Number.isNaN(tabIndex);
    return (isTabIndexNaN || tabIndex >= 0) && focusable(element);
}
function findTabbableDescendants(element) {
    return Array.from(element.querySelectorAll(FOCUS_SELECTOR)).filter(tabbable);
}

export { FOCUS_SELECTOR, findTabbableDescendants, focusable, tabbable };
